var map = {
	"./Live/Live_detail.vue": [
		"b9be",
		"chunk-55ce8f77",
		"chunk-3854c480"
	],
	"./mobile/Live/Live_detail.vue": [
		"a1e2",
		"chunk-55ce8f77",
		"chunk-c513b186",
		"chunk-31f5db90"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "85b6";
module.exports = webpackAsyncContext;